var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersContinuousLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 15.0637C27.0464 13.4043 30.0956 12.5723 33.1424 12.5723C36.1893 12.5723 39.2384 13.4043 42.2853 15.0637V37.7151C39.2384 36.1905 36.1893 35.4294 33.1424 35.4294C30.0956 35.4294 27.0464 36.1905 23.9996 37.7151M23.9996 15.0637V37.7151M23.9996 15.0637C20.9527 13.4043 17.9036 12.5723 14.8567 12.5723C11.8099 12.5723 8.76072 13.4043 5.71387 15.0637V37.7151C8.76072 36.1905 11.8099 35.4294 14.8567 35.4294C17.9036 35.4294 20.9527 36.1905 23.9996 37.7151",
    stroke: "url(#paint0_linear_1235_8213)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235_8213",
    x1: 5.71387,
    y1: 9.92925,
    x2: 44.5564,
    y2: 44.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersContinuousLearning);
export default __webpack_public_path__ + "static/media/Careers_Continuous_Learning.bb32ee9180abbf8952f02c8b8216d54d.svg";
export { ForwardRef as ReactComponent };